const slugify = require('slugify');
const queryString = require('query-string');
const config = require('../../config/site');

exports.getParamsFromUrlSearch = (search) => {
  const isClient = typeof search === 'string';
  const searchParams = isClient ? queryString.parse(search) : search;
  return searchParams;
};

exports.createPagePathOfPages = (pageType, pageCode) => {
  if (pageType === 'home') return '/';
  if (pageType === 'login') return `/${pageCode}`;

  const basePath = slugify(config.pages.slug || '');
  const pagePath = this.mergePathWithPage(basePath, pageCode);
  return pagePath;
};

exports.createRootPagePathOfCatalog = () => {
  const multiModuleMode = config.modules.multiModuleMode;

  let moduleSlug = config.modules.catalog.slug || '';
  moduleSlug = slugify(moduleSlug);

  const pagePath = '/';

  // module subpath
  if (multiModuleMode) {
    return `/${moduleSlug}${pagePath}`;
  } else {
    return pagePath;
  }
};

exports.createInitialAssortmentPagePathOfCatalog = (
  catalogType,
  assortments = [],
  catalogSettings = {}
) => {
  // TODO: with this solution the first assortment has to be available with the actual catalog !! Filter the assortments for the actual catalog.
  // Get some inspiration from gatsby-node.js - assortments
  const firstAssortment = assortments ? assortments[0] : {};
  const assortmentNode = firstAssortment ? firstAssortment.node : {};
  let basePath = '';
  let pageCode = '';
  if (assortmentNode) {
    basePath = config.catalog.assortment.slug;
    pageCode = assortmentNode.title;
  }
  return this.createPagePathOfMultiCatalog(catalogType, basePath, pageCode, catalogSettings);
};

exports.createPagePathOfMultiCatalog = (catalogType, basePath, pageCode, catalogSettings = {}) => {
  const multiModuleMode = config.modules.multiModuleMode;
  const { hasPrimary, primaryTitle } = catalogSettings;
  const { hasSecondary, secondaryTitle } = catalogSettings;
  const isPrimary = catalogType === config.catalog.catalog.primary;
  const isSecondary = catalogType === config.catalog.catalog.secondary;
  const addCatalogPath = hasPrimary && hasSecondary;

  let moduleSlug = config.modules.catalog.slug || '';
  moduleSlug = slugify(moduleSlug);
  const primaryIdSlug = slugify(primaryTitle);
  const secondaryIdSlug = slugify(secondaryTitle);

  let pagePath = this.mergePathWithPage(basePath, pageCode);

  // catalog subpath
  if (addCatalogPath) {
    if (isPrimary && pagePath === '/') {
      // only add primary catalog slug for catalog landing page
      pagePath = `/${primaryIdSlug}${pagePath}`;
    } else if (isSecondary) {
      pagePath = `/${secondaryIdSlug}${pagePath}`;
    }
  }
  // module subpath
  if (multiModuleMode) {
    pagePath = `/${moduleSlug}${pagePath}`;
  }

  return pagePath;
};

exports.createNodePathOfModule = (module, basePath) => {
  // used in gatsby-node/onCreateNode lifecycle event
  // ALL modules
  const multiModuleMode = config.modules.multiModuleMode;
  const isPages = module === 'pages';
  const isCatalog = module === 'catalog';

  let moduleSlug = '';
  if (isPages) moduleSlug = config.pages.slug || '';
  else moduleSlug = config.modules[module].slug || '';
  moduleSlug = slugify(moduleSlug);

  const pagePath = this.formatBasePath(basePath);

  // module subpath
  if (multiModuleMode) {
    if (isCatalog) {
      return pagePath;
    }
    return `/${moduleSlug}${pagePath}`;
  } else {
    if (isPages) {
      return `/${moduleSlug}${pagePath}`;
    }
    return pagePath;
  }
};

exports.mergePathWithPage = (basePath, pageCode) => {
  const pageCodeBase = pageCode === 'index' ? '' : pageCode;
  const pageCodeSlug = slugify(pageCodeBase);

  let mergePath = `/${basePath}/${pageCodeSlug}`;
  mergePath = mergePath.replace('//', '/');
  mergePath = mergePath.replace('//', '/');

  mergePath = this.formatBasePath(mergePath);
  return mergePath;
};

exports.formatBasePath = (basePath) => {
  // add trailing slash to path
  let formatPath = basePath ? `/${basePath}` : '/';

  if (config.gatsby && config.gatsby.trailingSlash) {
    formatPath = `${formatPath}/`;
  }
  formatPath = formatPath.replace('//', '/');
  formatPath = formatPath.replace('//', '/');

  return formatPath;
};
